import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { CASE_STUDIES } from "../lib/data";

export default function Portfolio() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });
  // translate the track horizontally as user scrolls the tall section
  const x = useTransform(scrollYProgress, [0, 1], ["2%", "-72%"]);

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      ref={ref}
      className="relative bg-[var(--bg-primary)]"
      style={{ height: "320vh" }}
    >
      <div className="sticky top-0 h-screen flex flex-col justify-center overflow-hidden">
        <div className="px-6 md:px-12 lg:px-16 mb-10 flex items-end justify-between">
          <div>
            <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[var(--accent-primary)]">
              03 — Portfolio
            </p>
            <h2 className="mt-4 font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white">
              Case studies
            </h2>
          </div>
          <span className="hidden md:block text-sm text-zinc-500">Scroll to explore →</span>
        </div>

        <motion.div style={{ x }} className="flex gap-6 md:gap-8 pl-6 md:pl-16 will-change-transform">
          {CASE_STUDIES.map((c, i) => (
            <article
              key={c.client}
              data-testid={`case-study-${i}`}
              className="group relative w-[78vw] sm:w-[56vw] md:w-[42vw] lg:w-[34vw] shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-[var(--bg-secondary)]"
            >
              <div className="relative h-[52vh] overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.client} — ${c.title}`}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)] via-transparent to-transparent" />
                <span className="absolute top-5 left-5 rounded-full bg-black/50 backdrop-blur px-3 py-1 text-xs font-medium uppercase tracking-wider text-white border border-white/10">
                  {c.category}
                </span>
              </div>
              <div className="p-6 md:p-7">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-zinc-400">{c.client}</span>
                  <span className="text-sm font-bold text-[var(--accent-secondary)]">{c.stat}</span>
                </div>
                <h3 className="mt-2 font-display text-xl md:text-2xl font-semibold text-white">
                  {c.title}
                </h3>
                <span className="mt-4 inline-flex items-center gap-2 text-sm text-zinc-500 group-hover:text-white transition-colors">
                  View case <ArrowRight size={15} />
                </span>
              </div>
            </article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
